<template>
  <div v-show="emailreq" class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-5">Potwierdź email</h1>
      <validation-observer v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(login)"
          method="post"
          id="wk"
          ref="wk"
          :action="action"
        >
          <input hidden value="wktemailreq" name="wktemailreq" />
          <input hidden :value="wkt" name="username" />
          <input hidden :value="regulation" name="req" />

          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email"
            vid="email"
            name="Adres e-mail"
          >
            <v-text-field
              v-model="email"
              label="Adres e-mail"
              title="Adres e-mail"
              name="password"
              :error-messages="errors"
              outlined
              persistent-placeholder
              placeholder="Wpisz adres e-mail"
              autocomplete="new-password"
              class="mb-2"
            />
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email|confirmed:email"
            name="Powtórz adres e-mail"
          >
            <v-text-field
              v-model="repeatEmail"
              label="Powtórz adres e-mail"
              @paste.prevent
              title="Powtórz adres e-mail"
              :error-messages="errors"
              outlined
              persistent-placeholder
              placeholder="Powtórz adres e-mail"
              autocomplete="new-password"
            />
          </ValidationProvider>

          <div class="pa-0" v-for="r in regulations" :key="r.regulationId">
            <ValidationProvider :rules="r.rules" v-slot="{ failed }">
              <v-checkbox
                v-model="regulation"
                persistent-hint
                :value="r.regulationId"
                :error="failed"
              >
                <template v-slot:label>
                  <div
                    class="ma-0"
                    @click.stop
                    v-if="r.shortContent.includes('href')"
                    v-html="r.shortContent"
                    title="Kliknij w link, aby otworzyć tą stronę"
                  />
                  <div
                    v-else
                    class="ma-0"
                    @click.stop
                    :title="tooltip.checkbox"
                    v-html="r.shortContent"
                  ></div>
                </template>
              </v-checkbox>
            </ValidationProvider>
          </div>
          <LoginAlerts
            :show="show"
            :type="color"
            :msg="text"
            @close="show = false"
            dismissible
          />
          <div class="actions">
            <v-btn
              type="submit"
              title="Kliknij, aby zalogować się do Elektronicznego Dziennika Budowy"
              large
              rounded
              color="primary"
              elevation="0"
              class="ml-2"
            >
              Potwierdź email
            </v-btn>
          </div>
        </form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import LoginAlerts from "../components/LoginAlerts.vue";

setInteractionMode("lazy");
extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("contains", {
  validate(value, args) {
    const val = args.value;
    return !!value.find(v => v == val);
  },
  params: ["value"]
});
export default {
  name: "LoginWK",
  components: {
    ValidationProvider,
    ValidationObserver,
    LoginAlerts
  },
  data() {
    return {
      action: process.env.VUE_APP_AUTH_REST_URL + "/login",
      timeout: 10000,
      text: "Niepoprawne dane logowania",
      color: "error",
      show: false,
      email: "",
      emailreq: false,
      wkt: null,
      errors: null,
      regulation: [],
      regulations: [],
      repeatEmail: ""
    };
  },
  metaInfo: {
    title: "Logowanie do EDB"
  },
  methods: {
    login() {
      document.getElementById("wk").submit();
    },
    loadRegulation() {
      return axios
        .get(`${process.env.VUE_APP_AUTH_REST_URL}/regulation`)
        .then(({ data }) => {
          return data;
        });
    },
    resetSnack() {
      setTimeout(() => {
        this.show = false;
      }, this.timeout + 1);
    }
  },
  mounted() {
    if (this.$route.query.wk) {
      if (!this.emailreq) document.getElementById("wk").submit();
    }
    if (this.$route.query.error) {
      this.text = decodeURIComponent(this.$route.query.error);
      this.color = "error";
      this.show = true;
      this.resetSnack();
    }
  },
  created() {
    this.wkt = this.$route.query.wk;
    this.emailreq = this.$route.query.emailreq === "true";
    this.loadRegulation().then(reg => {
      this.regulations = reg.map(r => {
        if (r.mustConfirm == true)
          r.rules = `required|contains:${r.regulationId}`;
        return r;
      });
    });
  }
};
</script>
